module.exports = __webpack_public_path__ + "img/bb_g3_mouth-04.296d11ae.svg";